import React, { useState, useEffect, useContext } from 'react';
import {Route, Routes} from "react-router-dom";

import Pass_Home from './pass/home.js';
import Pass_Shd from './pass/shd.js';
import Pass_Week from './pass/week.js';
import Pass_Plan from './pass/plan.js';
import {withRouter} from "../lib/react/withRouter";
import sso from "../sso";

function pg_home() {

    var html =
    <div className="web-content">
      Hem
    </div>
    ;
    return html;
}

class Ta_Pass extends React.Component {
    //var sdo = useContext(SDO);
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, deps: [] };
      var po = {};
      po.shd = { "fid": "f06", "url": "/ta/pass/shd", "name": "Passschema", "active": false };
      po.week = { "fid": "f06", "url": "/ta/pass/week", "name": "Veckopass", "active": false };
      po.plan = { "fid": "f06", "url": "/ta/pass/plan", "name": "Passplan", "active": false };
      this.state.po = po;
      this.state.pa = [];
      this.state.pa = Object.values(po);
  }
    fknGo(row) {
        sso.seo.sfkn = row;
        this.props.navigate(row.url);
    }
    br_css(row) {
        var css = {};
        if(sso.seo.sfkn && (row.url == sso.seo.sfkn.url)) css.color = "#080";
        //var brc = false;
        //if(row.url == sbo.state.url) brc = true;
        return css;
    }

  render() {
      //var path = window.location.pathname;
      //var op = path.split("/").pop();

    return (
        <div className="web-app">
            { this.props.store.cfg.bread ?
                <div className="web-bread">
                    <div className="breadcrumb">
                        { this.state.pa.map((row, key) =>
                            <div key={key} className="breadcrumb-item" style={this.br_css(row)} onClick={() => this.fknGo(row)}>{row.name}</div>
                        )}
                        <div className="flex"></div>
                        <div className="cdigreen">{ sso.seo.sfkn ? sso.seo.sfkn.name : null }</div>
                    </div>
                </div>
                : null }
        <Routes>
          <Route path="/xx" component={pg_home} />
            <Route path="shd" element={ <Pass_Shd store={this.webStore} />} />
            <Route path="week" element={ <Pass_Week store={this.webStore} />} />
            <Route path="plan" element={ <Pass_Plan store={this.webStore} />} />
            <Route path="*" element={ <Pass_Home store={this.webStore} />} />
        </Routes>
    </div>
  );
}
}
//Sys.contextType = ADOContext;

export default withRouter(Ta_Pass);
